import {
  OnboardedData,
  Metrics,
  Inventory,
} from '@/components/smartai/api/getComponentList';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const InitialMetricsState: Metrics = {
  inventoryModeCoverage: 0,
  linesOfCodeCoverage: 0,
  lineCoverage: 0,
  coveredLines: 0,
  totalLines: 0,
  testAutomationCount: 0,
  manualTestCount: 0,
};

const InitialInventoryState: Inventory = {
  files: 0,
  classes: 0,
  methods: 0,
  functions: 0,
  entities: 0,
  executableLines: 0,
};

const initialState: OnboardedData = {
  branchId: '',
  branchName: '',
  isDefault: false,
  orgId: '',
  orgName: '',
  repoId: '',
  repoName: '',
  environment: '',
  repoStatus: '',
  pat: '',
  projectId: '',
  projectName: '',
  scanId: '',
  lastScanAt: '',
  repoUrl: '',
  pipelineId: '',
  prEmails: [],
  metrics: InitialMetricsState,
  inventory: InitialInventoryState,
  dbRepoId: '',
  isView: false,
  displayName: '',
  frontendUrl: '',
  backendUrl: '',
  isWebhookEnabled: false,
  provider: undefined,
};

export const userSelectedComponentSlice = createSlice({
  name: 'userSelectedComponentSlice',
  initialState,
  reducers: {
    userSelectedComponent: (state, action: PayloadAction<OnboardedData>) => {
      return action.payload;
    },
    clearSelectedComponent: () => initialState,
  },
});

export const { userSelectedComponent, clearSelectedComponent } =
  userSelectedComponentSlice.actions;

export default userSelectedComponentSlice.reducer;
